// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3qr6n","inputWrap":"styles_inputWrap__3xUqq","input":"styles_input__olDBk"};